<template>
  <div class="container">
    <div class="title has-text-centered">Mentor Preferences </div>

    <div>
      <div class="field">
        <label class="label">Expected minimum mentorship duration</label>
        <div class="control">
          <div v-if="allow_editing" class="select is-fullwidth">
            <select
              v-model="settings.selected.expected_min_mentorship_duration"
            >
              <option v-bind:value="null" selected="selected">
                No minimum duration
              </option>
              <option
                v-for="min_duration in 18"
                v-bind:value="min_duration"
                v-bind:key="min_duration"
              >
                <div v-if="min_duration == 1">
                  {{ min_duration }} month
                </div> 
                <div v-else>
                  {{ min_duration }} months
                </div>
              </option>
            </select>
          </div>
          <div v-else class="box is-rounded p-3">
            {{
              settings.selected.expected_min_mentorship_duration ||
              'No minimum duration'
            }}
          </div>

          <FormErrors
            v-bind:errors="settings.errors.expected_min_mentorship_duration"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Expected maximum mentorship duration</label>
        <div class="control">
          <div v-if="allow_editing" class="select is-fullwidth">
            <select
              v-model="settings.selected.expected_max_mentorship_duration"
            >
              <option v-bind:value="null" selected="selected">
                No maximum duration
              </option>
              <option
                v-for="max_duration in 18"
                v-bind:value="max_duration"
                v-bind:key="max_duration"
              >
                <div v-if="max_duration == 1">
                  {{ max_duration }} month
                </div> 
                <div v-else>
                  {{ max_duration }} months
                </div>
              </option>
            </select>
          </div>
          <div v-else class="box is-rounded p-3">
            {{
              settings.selected.expected_max_mentorship_duration ||
              'No maximum duration'
            }}
          </div>

          <FormErrors
            v-bind:errors="settings.errors.expected_max_mentorship_duration"
          />
        </div>
      </div>

      <div class="field">
        <div class="control py-2">
          <div v-if="allow_editing">
            <label class="checkbox">
              <input
                type="checkbox"
                v-model="settings.selected.is_accepting_mentorship_requests"
              />
              Accepting new mentees
            </label>
          </div>
          <div v-else class="box">
            <div class="columns is-vcentered">
              <div class="column p-1">
                <strong>Is accepting mentorship requests?</strong>
              </div>
              <div class="column is-narrow p-1">
                <span
                  v-if="settings.selected.is_accepting_mentorship_requests"
                  class="box has-background-success is-shadowless py-1"
                >
                  Yes
                </span>
                <span
                  v-else
                  class="box has-background-danger is-shadowless py-1"
                >
                  No
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Accepted mentee types</label>
        <div class="control">
          <div v-if="allow_editing">
            <ul>
              <li
                v-for="mentee_type in settings.options.accepted_mentee_types"
                v-bind:key="mentee_type.id"
              >
                <label class="checkbox pb-2">
                  <input
                    type="checkbox"
                    v-bind:value="mentee_type.uid"
                    v-model="settings.selected.accepted_mentee_types"
                  />
                  {{ mentee_type.label }}
                </label>
              </li>
            </ul>
          </div>
          <div v-else class="content">
            <ul
              v-if="settings.selected.accepted_mentee_types && settings.selected.accepted_mentee_types.length === 0"
              style="list-style: none"
            >
              <li class="has-text-centered has-text-weight-bold p-3">
                No accepted mentee types
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="mentee_type in settings.selected
                  .accepted_mentee_type_labels"
                v-bind:key="mentee_type.id"
                class="pb-2"
              >
                {{ mentee_type }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="field">
        <label class="label">Responsibilities</label>
        <div class="control">
          <div v-if="allow_editing">
            <ul>
              <li
                v-for="responsibility in settings.options.responsibilities"
                v-bind:key="responsibility.id"
              >
                <label class="checkbox pb-2">
                  <input
                    type="checkbox"
                    v-bind:value="responsibility.uid"
                    v-model="settings.selected.responsibilities"
                  />
                  {{ responsibility.description }}
                </label>
              </li>
            </ul>
          </div>
          <div v-else class="content">
            <ul v-if="settings.selected.responsibilities.length === 0">
              <li class="box has-text-centered has-text-weight-bold p-3">
                No responsibilities
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="responsibility in settings.selected
                  .responsibility_descriptions"
                v-bind:key="responsibility.id"
                class="pb-2"
              >
                {{ responsibility }}
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <div class="field">
        <label class="label">URL listing mentees requirements (Optional)</label>
        <div class="control">
          <div v-if="allow_editing">
            <input
              class="input column mr-2"
              type="text"
              v-model="settings.selected.mentee_requirements_URL"
              placeholder="Enter a URL which contains requirements"
            >
          </div>
          <div v-else class="box p-3">
            <div v-if="settings.selected.mentee_requirements_URL">
              {{ settings.selected.mentee_requirements_URL }}
            </div>
            <div v-else>
              No data
            </div>
          </div>
        </div>
      </div>
      <div v-if="allow_editing" class="control">
        <button v-on:click="save" class="button is-fullwidth is-success">
          Update
        </button>
      </div>
      <br><br>
      <div class="field">
        <label class="label">Desired Mentee Skills</label>
        <div class="control ">
          <div clas = "buttons are-small" v-if="allow_editing">
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul v-else class="">
              <li
                v-for="item in settings.selected.priorities"
                v-bind:key="item.id"
                class="columns"
              >
                <p class="column is-four-fifths">{{ item.label }}</p>

                <p
                  class="column is-1 text-weight-bold tag is-light mr-6"
                  v-bind:class="{
                    'is-danger': item.priority === 2,
                    'is-warning': item.priority === 1,
                    'is-success': item.priority === 0,
                  }"
                >
                  {{ PRIORITY_VALUES[item.priority] }}
                </p> 
                <!-- <div class="select mr-2"> 
                  <select v-bind:key = "index" v-model="item.priorities" 
                    v-on:click = "edit_checklist_item(item, index)"
                  > 
                    <option disabled value="">Select Priority</option>
                    <option
                      v-for="(priority, index) in PRIORITY_VALUES"
                      v-bind:value="index"
                      v-bind:key="index"
                    >
                      {{ priority }}
                    </option>
                  </select>
                  </div> -->
                <button
                  class="button is-responsive is-danger mr-2"
                  v-on:click = "delete_checklist_item(item)" > Delete </button>
                <!-- <button
                  class="button is-responsive is-primary" 
                  v-on:click = "edit_checklist_item(item, new_priority)"> Edit </button> -->
              </li>
            </ul>
            <div class="columns my-3 mx-1">
              <input
                id="mentee_capability"
                class="input column is-four-fifths mr-2"
                placeholder="Enter mentee capability e.g. C, C++ or any other tool or technology."
                v-model="label"
              />
              <div class="">
                <div class="select mr-2">
                  <select v-model="priorityValue">
                    <option disabled value="">Select Priority</option>
                    <option
                      v-for="(priority, index) in PRIORITY_VALUES"
                      v-bind:value="index"
                      v-bind:key="index"
                    >
                      {{ priority }}
                    </option>
                  </select>
                </div>
                <button
                  class="button is-success"
                  v-on:click="add_checklist_item(label, priorityValue)"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <div v-else class="content">
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul v-else-if="settings.selected.priorities && settings.selected.priorities.length === 0">
              <li class="box has-text-centered has-text-weight-bold p-3">
                No items in Requirements
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="item in settings.selected.priorities"
                v-bind:key="item.id"
                class="pb-2"
              >
                <p>
                  {{ item.label }}
                  <span
                    v-bind:class="{
                      'is-danger': item.priority === 2,
                      'is-warning': item.priority === 1,
                      'is-success': item.priority === 0,
                    }"
                    class="tag is-light ml-2"
                  >
                    {{ PRIORITY_VALUES[item.priority] }}
                  </span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div>
        <label class="label">Projects for mentees</label>
      </div> -->

      <div class="field">
        <label class="label">Projects for mentees</label>
        <div class="control ">
          <div clas = "buttons are-small" v-if="allow_editing">
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul v-if="settings.options.projects.length != 0">
              <li
                v-for="project in settings.options.projects"
                v-bind:key="project.uid"
                class="box p-3"
              >
                <p>
                  <span style="font-weight: bolder;">Title: </span>{{ project.title }}
                  <br>
                  <span style="font-weight: bolder;">Details: </span>{{ project.details }}
                </p>

                <!-- <p
                  class="column"
                >
                </p> -->
                <p v-if="project.test_details">
                  <span style="font-weight: bolder;">Test or assignment Details: </span> {{ project.test_details }}
                  <br>
                  {{ project.test_file_name }} <br>
                  <button class="button is-responsive is-primary" v-if="project.test_file_name" v-on:click="download_file(project.test_file_name)">Download</button>
                </p>
                <button
                  class="button is-responsive is-info mr-2"
                  v-on:click = "edit_project(project)" > Edit </button>
                <button
                  class="button is-responsive is-danger mr-2"
                  v-on:click = "delete_project(project)" > Delete </button>
                
                <!-- <button
                  class="button is-responsive is-primary" 
                  v-on:click = "edit_checklist_item(item, new_priority)"> Edit </button> -->
              </li>
            </ul>
            <div v-else>
              No project to show.
            </div>
            <br><br>
            <button v-if="!edit_proj" class="button is-responsive is-info" v-on:click="toggle_project_form"> Add new project</button>
          </div>
          <div v-else class="content">
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul v-else-if="settings.options.projects && settings.options.projects.length === 0">
              <li class="box has-text-centered has-text-weight-bold p-3">
                No items in Requirements
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="project in settings.options.projects"
                v-bind:key="project.uid"
                class="box p-3"
              >
                <p>
                  <span style="font-weight: bolder;">Title: </span> {{ project.title }}
                  <br>
                  <span style="font-weight: bolder;">Details: </span> {{ project.details }}
                </p>

                <!-- <p
                  class="column"
                >
                </p> -->
                <p v-if="project.test_details">
                  <span style="font-weight: bolder;">Test or assignment Details:</span> {{ project.test_details }}
                  <br>
                  {{ project.test_file_name }} 
                  <br>
                  <button class="button is-responsive is-primary" v-if="project.test_file_name" v-on:click="download_file(project.test_file_name)">Download</button>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="control" v-if="add_new_project">
          <label v-if="!edit_proj" class="label">Add new project</label>
          <label v-else class="label">Edit Project</label>
          <div v-if="allow_editing">
            <p>Project Title</p>
            <input 
              type="text"
              class="input"
              placeholder="Project Title"
              v-model="settings.selected.project_title"
            >
            <p>Project Details</p>
            <textarea
              class="textarea"
              v-model="settings.selected.project_details"
              placeholder="If you are seeking interns for specific projects, please list URLs describing these projects or add a short paragraph below for each project.  Mentees wishing to apply to you for mentorship will have access to this information."
            >
            </textarea>
            <p>Screening test or programming assignment</p>
            <textarea
              class="textarea"
              v-model="settings.selected.test_details"
              placeholder="If you would like to give a screening test or programming assignment for the mentee to take, please upload a PDF file containing the test/assignment question with brief details here or indicate a URL where the mentee may find the test/assignment."
            >
            </textarea>
            <div v-if="settings.selected.test_file_name">
              <h1>{{ settings.selected.test_file_name }}</h1> 
              <button v-on:click="download_file" class="button is-primary">
                Download
              </button>
              <button v-on:click="delete_file" class="button is-danger">
                Delete
              </button>
            </div>
            <div v-else>
              <input type="file" name="" id="test_file" v-on:change="handleFile" ref="file">
            </div>
            <br>
            <button v-if="edit_proj" v-on:click="update_project" class="button is-success">
              Update
            </button>
            <button v-else v-on:click="save_project" class="button is-success">
              Save
            </button>
            <button v-on:click="toggle_project_form" class="button is-danger">
              Cancel
            </button>
          </div>
          <div v-else class="box p-3">
            <div v-if="settings.selected.project_details">
              {{ settings.selected.project_details }}
            </div>
            <div v-else>
              No data
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="field">
        <label class="label">Screening test or programming assignment</label>
        <div class="control">
          <div v-if="allow_editing">
            <textarea
              class="textarea"
              v-model="settings.selected.test_details"
              placeholder="If you would like to give a screening test or programming assignment for the mentee to take, please upload a PDF file containing the test/assignment question with brief details here or indicate a URL where the mentee may find the test/assignment."
            >
            </textarea>
            <br>
            <div v-if="settings.selected.test_file_name">
              <h1>{{ settings.selected.test_file_name }}</h1> 
              <button v-on:click="download_file" class="button is-primary">
                Download
              </button>
              <button v-on:click="delete_file" class="button is-danger">
                Delete
              </button>
            </div>
            <div v-else>
              <input type="file" name="" id="test_file" v-on:change="handleFile" ref="file">
              <button v-on:click="upload" class="button is-success">
                Upload
              </button>
            </div>
          </div>
          <div v-else class="box p-3">
            <div v-if="settings.selected.test_details">
              {{ settings.selected.test_details }}
            </div>
            <h1>{{ settings.selected.test_file_name }}</h1> 
            <button v-if="settings.selected.test_file_name" v-on:click="download_file" class="button is-primary">
              Download
            </button>
            <div v-if="settings.selected.test_file_name && settings.selected.test_file_name.length == 0 && settings.selected.test_details && settings.selected.test_details.length == 0">
              No data
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios, { API_URL } from '../../api/my-axios';
import FormErrors from '../FormHelpers/FormErrors';
import { PRIORITY_VALUES } from '../../lib';

export default {
  components: {
    FormErrors,
  },
  props: {
    is_editable: {
      type: Boolean,
      default: false,
    },
    profile_uid: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      PRIORITY_VALUES,
      allow_editing: true,
      to_show_profile_uid: this.profile_uid,
      add_new_project: false,
      edit_proj: false,

      settings: {
        request_token: {
          mentor: '',
        },

        errors: {},

        options: {
          accepted_mentee_types: [],
          responsibilities: [],
          projects: [],
        },

        selected: {
          expected_min_mentorship_duration: '',
          expected_max_mentorship_duration: '',
          is_accepting_mentorship_requests: true,
          accepted_mentee_types: [], // UIDs of the mentee types
          accepted_mentee_type_labels: [], // Labels of the mentee types
          responsibilities: [], // UIDs of the responsibilities
          responsibility_descriptions: [], // Labels of the responsibilities
          other_responsibility: '',
          mentee_requirements_URL: '',
          project_title: '',
          project_uid: '',
          project_details: '',
          test_details: '',
          test_file_name: '',
          priorities: [],
        },
        file: null,
      },
      showLoading: true,
    };
  },
  created() {
    this.to_show_profile_uid = this.profile_uid
      ? this.profile_uid
      : this.user.profile_uid;
    this.allow_editing = this.is_editable
      ? this.to_show_profile_uid === this.user.profile_uid
      : false;
    this.get_field_options();
    this.get_currently_selected_options();
  },
  methods: {
    get_field_options() {
      axios
        .get('/api/mentee/designation/')
        .then((response) => {
          this.settings.options.accepted_mentee_types = response.data;
        })
        .catch((error) => {
          this.settings.errors.accepted_mentee_types = error.response
            ? error.response.data
            : { detail: [error.message] };
        });

      // axios
      //   .get('/api/mentor/responsibility/')
      //   .then((response) => {
      //     console.log(response.data);
      //     this.settings.options.responsibilities = response.data;
      //   })
      //   .catch((error) => {
      //     this.settings.errors.responsibilities = error.response
      //       ? error.response.data
      //       : { detail: [error.message] };
      //   });
    },

    get_currently_selected_options() {

      axios
        .get(`/api/mentor/project/?mentor=${this.to_show_profile_uid}`)
        .then((response) => {
          this.settings.options.projects = response.data;
        })
        .catch((error) => {
          this.settings.errors.projects = error.response
            ? error.response.data
            : { detail: [error.message] };
      });
      
      axios
        .get(`/api/mentor/mentor/${this.to_show_profile_uid}/`)
        .then((response) => {
          console.log(response.data);
          for (const field in this.settings.selected) {
            this.settings.selected[field] = response.data[field];
          }

          this.showLoading = true;
          axios
            .get(`/api/mentor/checklist/?mentor=${this.to_show_profile_uid}`)
            .then((response) => {
              console.log(response.data);
              this.settings.selected.priorities = response.data;
              this.settings.selected.priorities.sort((a, b) =>
                a.priority > b.priority ? -1 : 1
              );
              this.showLoading = false;
            })
            .catch((err) => {
              throw new Error(err);
            });
        })
        .catch((error) => {
          console.error(error);
          this.settings.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    add_checklist_item(label, priority) {
      if (!label || priority === undefined) return;
      const item = {
        mentor: this.user.profile_uid,
        label,
        priority,
      };

      this.settings.selected.priorities.push(item); 
      axios.post(`/api/mentor/checklist/`, item)
      .then((response) => {
        document.getElementById("mentee_capability").value = "";
        item['uid'] = response.data.uid;
      });
    },

    delete_checklist_item(item) {
      var index = this.settings.selected.priorities.indexOf(item);  
      this.settings.selected.priorities.splice(index, 1);
      axios.delete(`/api/mentor/checklist/${item.uid}`)
    },

    edit_checklist_item(item, val) {
      var index = this.settings.selected.priorities.indexOf(item);
      this.settings.selected.priorities[index] = val;
      axios.patch(`/api/mentor/checklist/${item.uid}`,0); 
    },

    handleFile(){
      this.settings.file = this.$refs.file.files[0];
    },

    save_project(){
      if (!this.allow_editing) {
        return;
      }
      
      const formdata = new FormData();
      formdata.append('uid', this.settings.selected.project_uid);
      formdata.append('title', this.settings.selected.project_title);
      formdata.append('details', this.settings.selected.project_details);
      formdata.append('test_details', this.settings.selected.test_details);
      formdata.append('file', this.settings.file);
      const headers = { 'Content-Type': 'multipart/form-data' };
      axios
      .post(`/api/mentor/project/`, formdata, {headers})
      .then(() => {
        this.get_currently_selected_options();
        this.toggle_project_form();
      })
    },

    delete_project(project){
      console.log(project)
      axios.delete(`/api/mentor/project/${project.uid}/`)
      .then(() => {
        const index = this.settings.options.projects.indexOf(project);
        if (index > -1) { // only splice array when item is found
          this.settings.options.projects.splice(index, 1); // 2nd parameter means remove one item only
        }
      })
      // this.get_currently_selected_options();
    },

    edit_project(project){
      if (!this.allow_editing) {
        return;
      }
      this.toggle_project_form();
      this.edit_proj = true;
      // window.scrollTo(0,9999);
      setTimeout(()=>  window.scrollTo(0,9999), 100)
      // const formdata = new FormData();
      this.settings.selected.project_uid = project.uid
      this.settings.selected.project_title = project.title
      this.settings.selected.project_details = project.details
      this.settings.selected.test_details = project.test_details
      this.settings.selected.test_file_name = project.test_file_name
      
      // formdata.append('uid', this.settings.selected.project_uid);
      // formdata.append('title', this.settings.selected.project_title);
      // formdata.append('details', this.settings.selected.project_details);
      // formdata.append('test_details', this.settings.selected.test_details);
      // formdata.append('file', this.settings.file);
      // const headers = { 'Content-Type': 'multipart/form-data' };
      // axios
      // .patch(`/api/mentor/project/`, formdata, {headers})
      // .then(() => {
      //   this.get_currently_selected_options();
      //   this.toggle_project_form();
      // })
    },

    update_project(){
      const formdata = new FormData();
      // this.settings.selected.project_uid = project.uid
      // this.settings.selected.project_title = project.title
      // this.settings.selected.project_details = project.details
      // this.settings.selected.test_details = project.test_details
      // this.settings.selected.test_file_name = project.test_file_name
      
      formdata.append('uid', this.settings.selected.project_uid);
      formdata.append('title', this.settings.selected.project_title);
      formdata.append('details', this.settings.selected.project_details);
      formdata.append('test_details', this.settings.selected.test_details);
      formdata.append('file', this.settings.file);
      const headers = { 'Content-Type': 'multipart/form-data' };
      axios
      .patch(`/api/mentor/project/${this.settings.selected.project_uid}/`, formdata, {headers})
      .then(() => {
        this.get_currently_selected_options();
        this.toggle_project_form();
      })
    },

    delete_file(){
      axios
      .post(`/api/mentor/delete_file/`, {uid: this.settings.selected.project_uid})
      .then(() => {
        this.get_currently_selected_options();
      })
    },

    download_file(file_name){
      console.log(API_URL)
      var url = API_URL+ 'media/tests_files/'+file_name;
      window.open(url, '_blank');
    },

    toggle_project_form(){
      this.settings.selected.project_details = "";
      this.settings.selected.project_title = "";
      this.settings.selected.project_uid = "";
      this.settings.selected.test_details = "";
      this.settings.selected.test_file_name = "";
      this.add_new_project = !this.add_new_project;
      this.edit_proj = false;
    },

    save() {
      if (!this.allow_editing) {
        return;
      }

      if (!this.settings.selected.expected_min_mentorship_duration) {
        this.settings.selected.expected_min_mentorship_duration = null;
      }

      if (!this.settings.selected.expected_max_mentorship_duration) {
        this.settings.selected.expected_max_mentorship_duration = null;
      }

      if (this.settings.selected.expected_min_mentorship_duration && this.settings.selected.expected_max_mentorship_duration){
        if (this.settings.selected.expected_max_mentorship_duration < this.settings.selected.expected_min_mentorship_duration){
          this.settings.errors.expected_max_mentorship_duration = "Max expected duration should be greater then min expected duration.";
          this.$store.commit("set_show_alert", {show: true, message: 'Incorrect value of max expected duration', type: 'danger'});
          setTimeout(() => {
            this.$store.commit("set_show_alert", {show: false, message: '', type: ''});
          }, 1000);
          return;
        }
        else{
          this.settings.errors.expected_max_mentorship_duration = ""
        }
      }

      axios
        .patch(`/api/mentor/mentor/${this.user.profile_uid}/`, {
          ...this.settings.selected,
        })
        .then(() => {
          this.$forceUpdate()
          this.$store.commit("set_show_alert", {show: true, message: 'Mentor preferences updated', type: 'primary'});
          setTimeout(() => {
              this.$store.commit("set_show_alert", {show: false, message: '', type: ''});
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
